import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.object.to-string";
export default function _isFunction(x) {
  return Object.prototype.toString.call(x) === '[object Function]';
}